import React from 'react';
import { useTranslation } from 'react-i18next';
import './SessionWarningModal.css';

interface SessionWarningModalProps {
  isOpen: boolean;
  secondsRemaining: number;
  onExtendSession: () => void;
  onLogout: () => void;
}

const SessionWarningModal: React.FC<SessionWarningModalProps> = ({
  isOpen,
  secondsRemaining,
  onExtendSession,
  onLogout,
}) => {
  const { t } = useTranslation("popups");
  if (!isOpen) return null;

  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="session-warning-icon">
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h2 className="session-warning-title">{t("sessionWarningModal.title")}</h2>

        <p className="session-warning-message">
          {t("sessionWarningModal.message")}
        </p>

        <div className="session-warning-countdown">
          <span className="countdown-time">{timeDisplay}</span>
          <span className="countdown-label">{t("sessionWarningModal.remaining")}</span>
        </div>

        <div className="session-warning-actions">
          <button
            className="session-btn session-btn-secondary"
            onClick={onLogout}
          >
            {t("sessionWarningModal.logoutNow")}
          </button>
          <button
            className="session-btn session-btn-primary"
            onClick={onExtendSession}
          >
            {t("sessionWarningModal.stayLoggedIn")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarningModal;
